export const DEFAULT_IMAGE =
  "https://cdn.outschool.com/outschool-filestack-migration/0wotKfsgR4iMbewMMtEJ_Placeholder.png";
export const DEFAULT_PROFILE_IMAGE =
  "https://cdn.outschool.com/outschool-filestack-migration/V7Iy0eR9CdpoHexqhqQj_avatar.png";
/** Fallback card asset for Edmentum Guided catalog listings, which have no photos of their own. */
export const EDMENTUM_LOGO_IMAGE =
  "https://cdn.outschool.com/outschool-filestack-general/guided-catalog/edmentum-logo.png";
